import { DeleteOutlined, EditOutlined, ShoppingCartOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Space, Tooltip } from "antd";
import HTTPService from "../../../utils/makerequest";
import { IPageData, IPageProps } from "../../../interfaces/page-data";
import { useEffect, useRef, useState } from "react";
import { Toast } from 'primereact/toast';
import "../CompanyManagement/CustomerManagement.css";
import { IAuthentication, UserRole } from "../../../interfaces/authentication";
import { StateLoader } from "../../../redux/StateLoader";
import { useTranslation } from 'react-i18next'; // Ekleyin
import { ISupplierData } from "../../../interfaces/ISupplierData";
import i18n from "../../../i18n";
import MUIDatagrid, { IMUIDataGridColumns } from "../../../AltisComponent/MUIDataGrid";

export interface ISupplier {
  count?: number;
  data?: ISupplierData[];
}

const SupplierManagement: React.FunctionComponent<IPageProps> = (props) => {
  const { onSetPage } = props;
  const { t } = useTranslation();
  const toast = useRef<any>(null);
  const loader = new StateLoader();
  const [supplierDatas, setSupplierDatas] = useState<ISupplier>({});
  const userInfo: IAuthentication = loader.loadAuthState();
  const dataGridRef = useRef<any>(null);

  const pageData: IPageData = {
    title: t('supplier_management'),
    loaded: true
  };

  useEffect(() => {
    onSetPage(pageData);
    dataGridRef.current.GetAllData();
  }, [i18n.language]);

  const isAltisAdmin = userInfo?.role === UserRole.AltisAdmin;

  const columns: IMUIDataGridColumns[] = [
    ...(userInfo.role == UserRole.AltisAdmin ? [{
      title: t('Company Name'),
      key: 'companyName',
      isSorting: true,
      placeHolder: t('Company Name'),
    }] : []),
    { title: t('supplier'), isSorting: true, key: 'supplierName', placeHolder: t('supplier'), align: 'center', headerAlign: 'center' },
    { title: t('supplier_count'),hideColumnMenu:true, isSorting: false, key: 'supplierCount', placeHolder: t('supplier_count'), align: 'center', headerAlign: 'center' },
    {
      title: t('operations'),
      key: 'operations',
      placeHolder: t('operations'),
      align: 'center',
      headerAlign: 'center',
      hideColumnMenu: true,
      render: (order, record) => (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',marginTop:10 }}>
          <Space size={8}>
            <Popconfirm
              title={<div>{t('are_you_sure_supplier')} <br /></div>}
              onConfirm={() => DeleteSupplier(record.supplierId)}
              okText={t('yes')}
              cancelText={t('no')}
            >
              <Tooltip title={t('delete')}>
                <Button
                  size='small'
                  icon={<DeleteOutlined />}
                  onClick={(e) => { e.stopPropagation(); }}
                  style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
                >
                </Button>
              </Tooltip>

            </Popconfirm>

            <Tooltip title={t('update')}>
              <Button
                size='small'
                icon={<EditOutlined />}
                onClick={() => window.location.replace('/admin/update-supplier/' + record.supplierId)}
                style={{ display: userInfo.role === UserRole.Sayman ? 'none' : 'block', width: '60px', borderRadius: '70px' }}
              >
              </Button>
            </Tooltip>
          </Space>
        </div>
      ),
    }
  ];

  const SupplierFilter = (e?) => {
    const filters = e?.filters;
    const body = {
      sortColumn: e?.sortField,
      sortOrder: e?.sortOrder || 'asc',
      pageSize: e?.pageSize,
      page: e?.page,
      supplierName: filters?.supplierName,
      filterCompanyName: filters?.companyName,
      supplierCounts: e?.supplierCounts
    };

    HTTPService.POST(`/Supplier/filters`, body).then((response) => {
      if (!response.data) return;
      if (response.status === 200) {
        const tmp: ISupplier = response.data;
        tmp.data?.map((elem, index) => {
          elem['key'] = index;
        });
        setSupplierDatas(tmp);
      } else {
        toast.current?.show({
          severity: 'error',
          summary: t('mistake'),
          detail: t(response.data),
          life: 3000
        });
      }
    });
  };

  const DeleteSupplier = (Id) => {
    HTTPService.DELETE(`/Supplier/deleteSupplier?Id=${Id}`).then(
      (response) => {
        if (response.status === 200) {
          toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t(response.data),
            life: 3000
          });
          dataGridRef.current.GetAllData();
        } else {
          toast.current?.show({
            severity: 'error',
            summary: t('mistake'),
            detail: t(response.data),
            life: 3000
          });
        }
      }
    );
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="row">
        <div className="col-md-4 mb-3">
          <Button
            type="primary"
            shape="round"
            style={{
              height: 64,
              width: 'auto',
              backgroundColor: 'transparent',
              color: '#1890ff',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: '5px',
              padding: 0,
              border: 'none',
              transition: 'all 0.3s ease',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
              e.currentTarget.style.color = '#40a9ff';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
              e.currentTarget.style.color = '#1890ff';
            }}
            size="middle"
            onClick={() => window.location.replace('/admin/add-supplier')}
          >
            <ShoppingCartOutlined style={{ fontSize: 24 }} />
            <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
              {t('add_supplier_category')}
            </span>
          </Button>

        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="table-container">
            <MUIDatagrid enableSelection={false} ref={dataGridRef} data={supplierDatas.data} total={supplierDatas.count} columns={columns} filterMode="server" onChange={SupplierFilter} />
          </div>
        </div>
      </div>
    </>
  );
};

export default SupplierManagement;
